import ListingThumbnail from "../listings/ListingThumbnail";
import priceFormat from "../../utils/priceFormat";
import { formatAgentName } from "../upcomingListings/listingDisplay";
import { HOST_STATUS, formatSlotDay, formatSlotRange, hostStatus } from "./openHouseDisplay";

const PILL = {
  [HOST_STATUS.ASSIGNED]: "bg-[#eef1f6] text-secondary",
  [HOST_STATUS.NEEDED]: "bg-[#fdeceb] text-[#cd2026]",
  [HOST_STATUS.NOT_NEEDED]: "bg-[#f4f7e4] text-[#5f6d0b]",
};

/**
 * One open-house slot. A listing with a Saturday and a Sunday slot renders two
 * of these, each with its own host — which is the whole reason the query is
 * per-occurrence rather than per-listing.
 */
const OpenHouseRow = ({ occurrence, canAssign, onAssign }) => {
  const status = hostStatus(occurrence);
  const listing = occurrence.listing ?? {};
  const agent = formatAgentName(listing.user);

  return (
    <div className="flex items-center gap-3 border-b border-gray-100 px-3 py-3 last:border-b-0">
      <ListingThumbnail photos={listing.imageURLs ?? []} size={54} />

      <div className="w-[130px] shrink-0">
        <div className="text-xs font-bold text-secondary">
          {formatSlotDay(occurrence) ?? "Date unavailable"}
        </div>
        <div className="text-[11px] text-gray-400">{formatSlotRange(occurrence)}</div>
      </div>

      <div className="min-w-0 flex-1">
        <div className="truncate text-xs font-bold text-secondary">
          {listing.streetAddr}
        </div>
        <div className="truncate text-[11px] text-gray-400">
          {[
            [listing.city, listing.state].filter(Boolean).join(", "),
            agent && `Listing: ${agent}`,
          ]
            .filter(Boolean)
            .join(" · ")}
        </div>
      </div>

      <div className="w-[84px] shrink-0 text-right text-xs font-black text-primary_dark">
        {listing.price ? `$${priceFormat(listing.price)}` : null}
      </div>

      <div className="w-[190px] shrink-0 text-right">
        <span
          className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-bold ${PILL[status.kind]}`}
        >
          {status.label}
        </span>
      </div>

      {canAssign && (
        <div className="w-[78px] shrink-0 text-right">
          <button
            type="button"
            onClick={() => onAssign(occurrence)}
            className={`rounded-sm px-2.5 py-1 text-[11px] font-bold ${
              status.kind === HOST_STATUS.ASSIGNED
                ? "border border-gray-300 text-gray-500 hover:text-secondary"
                : "bg-primary text-white hover:opacity-90"
            }`}
          >
            {status.kind === HOST_STATUS.ASSIGNED ? "Change" : "Assign"}
          </button>
        </div>
      )}
    </div>
  );
};

export default OpenHouseRow;
